/* istanbul ignore */
import SelectProvinceField from './SelectProvinceField'

export default SelectProvinceField
